import React from "react";
import {CircularProgressbar, buildStyles} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import AnimatedProgressProvider from "../layout/AnimatedProgressProvider";

import AOS from "aos";
AOS.init();

const hero = () => {
	return (
		<div className="v-center">
			<div className="container">
				<div className="row">
					<div className="col-md-12 text-center">
						<h2
							data-aos="fade-up"
							data-aos-delay="0"
							data-aos-duration="1000"
							data-aos-easing="ease"
							data-aos-once="true"
						>
							About Me
						</h2>
						<div
							className="space-border"
							data-aos="fade-up"
							data-aos-delay="20"
							data-aos-duration="1000"
							data-aos-easing="ease"
							data-aos-once="true"
						></div>
					</div>
					<div
						className="col-md-8 text-center m-auto"
						data-aos="fade-up"
						data-aos-delay="60"
						data-aos-duration="1000"
						data-aos-easing="ease"
						data-aos-once="true"
					>
						<p>
							LinkedIn top 5% JavaScript developer.With three years of dedicated
							frontend development experience, I have honed my skills in
							crafting dynamic and user-centric web interfaces. Proficient in a
							range of modern technologies, including HTML, CSS, JavaScript, and
							popular frontend frameworks like React and Vue.js, I have a proven
							track record of transforming design concepts into visually
							stunning, responsive, and high-performance web applications. My
							expertise in responsive design, cross-browser compatibility, and
							code optimization is coupled with a passion for user experience
							and an unwavering commitment to best practices. As a Frontend
							Developer, I am poised to create innovative and captivating
							digital experiences that leave a lasting impact
						</p>
					</div>
				</div>
				<div className="row">
					<div
						className="col-lg-3 p-5 text-center"
						data-aos="fade"
						data-aos-delay="300"
						data-aos-duration="1000"
						data-aos-easing="ease"
						data-aos-once="true"
					>
						<AnimatedProgressProvider valueStart={0} valueEnd={90}>
							{value => {
								const roundedValue = Math.round(value);
								return (
									<CircularProgressbar
										value={value}
										strokeWidth={3}
										text={`${roundedValue}.0%`}
										styles={buildStyles({
											pathTransition: "none",
											textColor: "white",
											textSize: "8px",
											pathColor: "#cf1f1f",
											trailColor: "#2f3134",
										})}
									/>
								);
							}}
						</AnimatedProgressProvider>
						<h4 className="mt-2">HTML</h4>
					</div>
					<div
						className="col-lg-3 p-5 text-center"
						data-aos="fade"
						data-aos-delay="400"
						data-aos-duration="1000"
						data-aos-easing="ease"
						data-aos-once="true"
					>
						<AnimatedProgressProvider valueStart={0} valueEnd={85}>
							{value => {
								const roundedValue = Math.round(value);
								return (
									<CircularProgressbar
										value={value}
										strokeWidth={3}
										text={`${roundedValue}.0%`}
										styles={buildStyles({
											pathTransition: "none",
											textColor: "white",
											textSize: "8px",
											pathColor: "#cf1f1f",
											trailColor: "#2f3134",
										})}
									/>
								);
							}}
						</AnimatedProgressProvider>
						<h4 className="mt-2">CSS</h4>
					</div>
					<div
						className="col-lg-3 p-5 text-center"
						data-aos="fade"
						data-aos-delay="500"
						data-aos-duration="1000"
						data-aos-easing="ease"
						data-aos-once="true"
					>
						<AnimatedProgressProvider valueStart={0} valueEnd={80}>
							{value => {
								const roundedValue = Math.round(value);
								return (
									<CircularProgressbar
										value={value}
										strokeWidth={3}
										text={`${roundedValue}.0%`}
										styles={buildStyles({
											pathTransition: "none",
											textColor: "white",
											textSize: "8px",
											pathColor: "#cf1f1f",
											trailColor: "#2f3134",
										})}
									/>
								);
							}}
						</AnimatedProgressProvider>
						<h4 className="mt-2">JavaScript</h4>
					</div>
					<div
						className="col-lg-3 p-5 text-center"
						data-aos="fade"
						data-aos-delay="600"
						data-aos-duration="1000"
						data-aos-easing="ease"
						data-aos-once="true"
					>
						<AnimatedProgressProvider valueStart={0} valueEnd={75}>
							{value => {
								const roundedValue = Math.round(value);
								return (
									<CircularProgressbar
										value={value}
										strokeWidth={3}
										text={`${roundedValue}.0%`}
										styles={buildStyles({
											pathTransition: "none",
											textColor: "white",
											textSize: "8px",
											pathColor: "#cf1f1f",
											trailColor: "#2f3134",
										})}
									/>
								);
							}}
						</AnimatedProgressProvider>
						<h4 className="mt-2">React Vue Next</h4>
					</div>
				</div>
			</div>
		</div>
	);
};

export default hero;
